export default __webpack_public_path__ + "static/media/signal-warning.18b78428.png";